import React from 'react';

const Search = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" {...props}>
    <path
      fillRule="evenodd"
      d="M11.962 13.376a6.002 6.002 0 0 1-7.72-9.133 6 6 0 0 1 9.134 7.72l4.304 4.303a.996.996 0 0 1-.002 1.412c-.39.39-1.028.386-1.412.002l-4.304-4.304zm-.648-2.062a4 4 0 1 0-5.657-5.657 4 4 0 0 0 5.657 5.657z"
    />
  </svg>
);

export default Search;
